var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"51038a9b585aedfbc25d6e86904a219e73bc75d7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["supabase-app-staging@supabase"]={id:"51038a9b585aedfbc25d6e86904a219e73bc75d7"};
      